// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H14V10.2792L15 9.94591L22 12.2792V22H16V16H14V22H2V2ZM8 12.2792L12 10.9459V4H4V20H8V12.2792Z"}}]};

const City11FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-11-filled',
    ref,
    icon: element,
  },
));

City11FilledIcon.displayName = 'City11FilledIcon';

export default City11FilledIcon;
